import { CartEntry } from "../../../library-js/php/cart/CartEntry";
import { Request } from "../../../library/ts/html/server/Request";
import { AssetInfo } from "./AssetInfo";
import { AssetsCart } from "./AssetsCart";

export class AssetManagerServer
{
  static readonly serverURL = "http://localhost:1780";

  readonly assetsCart = new AssetsCart();

  async post<I,O>( path:string, input:I ):Promise<O> 
  {
    let url = AssetManagerServer.serverURL + "/" + path;
    let result = await Request.post( url, input );

    return Promise.resolve( result as O );
  }


  async getInfo( assetID:string ):Promise<AssetInfo>
  {
    let input = { id: assetID };
    let info = await this.post( "asset-info", input ) as AssetInfo;

    return Promise.resolve( info );
  }
   

  async getItems( fromWishlist:boolean ):Promise<AssetInfo[]>
  {
    let cart = this.assetsCart;

    await cart.sync();

    let items = fromWishlist ? cart.wishlist : cart.cart;

    let assetInfos:AssetInfo[] = [];

    for ( let id of items )
    {
      let assetInfo = await this.getInfo( id );
      assetInfos.push( assetInfo );
    }
    
    return Promise.resolve( assetInfos );
  }

  async getCartEntries( fromWishlist:boolean ):Promise<CartEntry[]>
  {
    let assetInfos = await this.getItems( fromWishlist );

    let cartEntries:CartEntry[] = [];

    assetInfos.forEach(
      ( ai )=>
      {
        let index =  cartEntries.findIndex( ce => ce.id === ai.id );

        if ( index === -1 )
        {
          let cartEntry = new CartEntry();
          cartEntry.id = ai.id;
          cartEntry.amount = 0;
          
          index = cartEntries.length;
          cartEntries.push( cartEntry );
        }

        cartEntries[ index ].amount ++;
      }
    )

    return Promise.resolve( cartEntries );
  }
}